import { useEffect, useState } from "react";
import { listNegativeMaterials, type NegativeMaterial } from "@/lib/service/materialUsageClient";

export function NegativeOnHandBanner() {
  const [materials, setMaterials] = useState<NegativeMaterial[]>([]);

  useEffect(() => {
    let cancelled = false;
    void listNegativeMaterials().then((result) => {
      if (cancelled || !result.ok) return;
      setMaterials(result.data.materials);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  if (materials.length === 0) return null;
  return (
    <div
      role="status"
      className="rounded-lg border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950 dark:border-amber-500/60 dark:bg-amber-950/40 dark:text-amber-100"
    >
      <p className="font-medium">
        {materials.length === 1
          ? "A material is below zero. Please fix inventory."
          : `${materials.length} materials are below zero. Please fix inventory.`}
      </p>
      <ul className="mt-1 space-y-0.5">
        {materials.slice(0, 8).map((material) => (
          <li key={material.id}>
            {material.plant_name ? `${material.plant_name}: ` : ""}
            {material.name} ({material.on_hand_qty})
          </li>
        ))}
      </ul>
    </div>
  );
}
